import { useState } from "react";
import { format, subDays, startOfMonth, endOfMonth, subMonths } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CalendarIcon, Filter } from "lucide-react";

const iso = (d) => format(d, "yyyy-MM-dd");
export const defaultPeriod = () => ({ from: iso(subDays(new Date(), 29)), to: iso(new Date()) });

const QUICK = [
  { k: "today", label: "Hoje", fn: () => ({ from: iso(new Date()), to: iso(new Date()) }) },
  { k: "yesterday", label: "Ontem", fn: () => ({ from: iso(subDays(new Date(), 1)), to: iso(subDays(new Date(), 1)) }) },
  { k: "7d", label: "Últimos 7 dias", fn: () => ({ from: iso(subDays(new Date(), 6)), to: iso(new Date()) }) },
  { k: "30d", label: "Últimos 30 dias", fn: () => defaultPeriod() },
  { k: "month", label: "Este mês", fn: () => ({ from: iso(startOfMonth(new Date())), to: iso(endOfMonth(new Date())) }) },
  { k: "prev", label: "Mês anterior", fn: () => ({ from: iso(startOfMonth(subMonths(new Date(), 1))), to: iso(endOfMonth(subMonths(new Date(), 1))) }) },
];

const parse = (s) => new Date(s + "T12:00:00");
const fmt = (s) => format(parse(s), "dd/MM/yyyy");

export function PeriodPicker({ value, onApply }) {
  const [draft, setDraft] = useState(value);
  const [open, setOpen] = useState(false);
  const range = { from: parse(draft.from), to: parse(draft.to) };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="period-picker">
      <p className="text-xs font-bold uppercase tracking-wider text-slate-500 mr-1">Período</p>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" className="h-9 font-mono text-sm" data-testid="period-calendar-btn">
            <CalendarIcon className="w-4 h-4 mr-2 text-emerald-600" />{fmt(draft.from)} → {fmt(draft.to)}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-white dark:bg-slate-900" align="start">
          <Calendar mode="range" numberOfMonths={2} locale={ptBR} selected={range}
            onSelect={(r) => { if (r?.from) setDraft({ from: iso(r.from), to: iso(r.to || r.from) }); }} />
          <div className="p-2 border-t flex justify-end">
            <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700" onClick={() => { setOpen(false); onApply(draft); }} data-testid="period-apply-calendar-btn">Aplicar filtro</Button>
          </div>
        </PopoverContent>
      </Popover>
      <div className="flex gap-1 flex-wrap">
        {QUICK.map((q) => (
          <Button key={q.k} size="sm" variant="ghost" className="h-8 text-xs" data-testid={`period-quick-${q.k}`}
            onClick={() => { const p = q.fn(); setDraft(p); onApply(p); }}>{q.label}</Button>
        ))}
      </div>
      <Button size="sm" className="h-8 bg-emerald-600 hover:bg-emerald-700" onClick={() => onApply(draft)} data-testid="period-filter-btn"><Filter className="w-3.5 h-3.5 mr-1" /> Filtrar</Button>
    </div>
  );
}
